// project import
import Routes from 'routes';
import ThemeCustomization from 'themes';
import ScrollTop from 'components/ScrollTop';
import { ToastContainer } from 'react-toastify';

  import 'react-toastify/dist/ReactToastify.css';
// ==============================|| APP - THEME, ROUTER, LOCAL  ||============================== //

const App = () => (
 <>
  <ThemeCustomization>
    <ScrollTop>
      <Routes />
    </ScrollTop>
  <ToastContainer />
  </ThemeCustomization>
  </>
);

export default App;
